/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Status_DraftInputs */

const vi_stocktake_status_draft = /** @type {(inputs: Stocktake_Status_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nháp`)
};

/**

* @param {Stocktake_Status_DraftInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_status_draft = /** @type {((inputs?: Stocktake_Status_DraftInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Status_DraftInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_status_draft(inputs)
});